module.exports = __webpack_public_path__ + "img/porto-8.40e05b97.png";